import React from "react";
import { connect } from "react-redux";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import AperturaScheduler from "./AperturaScheduler";
import ModalEditWeek from "./ModalEditWeek";
import ModalConflictWeek from "./ModalConflictWeek";
import ModalDeleteOpening from "./ModalDeleteOpening";

class Aperturas extends React.PureComponent {
  render() {
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <ModalEditWeek />
        <ModalConflictWeek />
        <ModalDeleteOpening />
        <AperturaScheduler />
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.aperturasSel.isLoading,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Aperturas);
